import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { DEFAULT_TIMEOUT } from '../clients';
import { environmentService } from '../config/di/container';

const instance = axios.create({
  baseURL: environmentService.getDataProcessingAgreementStorageUrl(),
  timeout: DEFAULT_TIMEOUT
});

const api = (axios: AxiosInstance) => {
  return {
    get: <T>(url: string, config: AxiosRequestConfig = {}) => {
      return axios.get<T>(url, config);
    }
  };
};

export const StorageHttp = api(instance);
